import React, { FC } from "react"
import { AuthConsumer } from "../components/context/auth/authContext"
import { navigate } from "gatsby"
import PageSpinner from "../components/pageSpinner"

const IndexPage: FC = () => {
  return typeof window !== "undefined" ? (
    <AuthConsumer>
      {context =>
        context.loading ? (
          <PageSpinner />
        ) : context.authenticated ? (
          navigate("/dashboard")
        ) : (
          navigate("/login")
        )
      }
    </AuthConsumer>
  ) : (
    <></>
  )
}

export default IndexPage
